// extracted by mini-css-extract-plugin
export default {"divider":"divider_divider__9xFC1","thickDivider":"divider_thickDivider__5qE5E"};